import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'account.settings.coaching.consent.welcome.header': {
    id: 'account.settings.coaching.consent.welcome.header',
    defaultMessage: 'Let’s get started.',
    description: 'The welcome header for consent form.',
  },
  'account.settings.coaching.consent.welcome.subheader': {
    id: 'account.settings.coaching.consent.welcome.subheader',
    defaultMessage: "We're here for you from start to finish",
    description: 'The welcome subheader for consent form.',
  },
  'account.settings.coaching.consent.description': {
    id: 'account.settings.coaching.consent.description',
    defaultMessage: "MicroBachelors programs include coaching that focuses on your career, education, and how you'll achieve results through one-on-one communication with an experienced professional. If you’re interested, provide the information below and click “Submit,” and our coaching partner will connect with you via email and/or text message to help you move forward. Terms and conditions apply.*",
    description: 'Text describing what Coaching is.',
  },
  'account.settings.coaching.consent.text-messaging.disclaimer': {
    id: 'account.settings.coaching.consent.text-messaging.disclaimer',
    defaultMessage: '* Coaching services are included at no additional cost to learners with US phone numbers. Coaching includes recurring text messages. Message and data rates may apply. Text STOP to opt-out.',
    description: 'Text describing what Coaching is.',
  },
  'account.settings.coaching.consent.accept-coaching': {
    id: 'account.settings.coaching.consent.accept-coaching',
    defaultMessage: 'Sign up for coaching',
    description: 'Text to confirm coaching enablement',
  },
  'account.settings.coaching.consent.decline-coaching': {
    id: 'account.settings.coaching.consent.decline-coaching',
    defaultMessage: 'I prefer not to be contacted with free coaching services',
    description: 'Text to decline coaching enablement',
  },
  'account.settings.coaching.consent.label.name': {
    id: 'account.settings.coaching.consent.label.name',
    defaultMessage: 'Please confirm your name',
    description: 'Label for name input',
  },
  'account.settings.coaching.consent.label.phone-number': {
    id: 'account.settings.coaching.consent.label.phone-number',
    defaultMessage: 'Enter your mobile number',
    description: 'Label for mobile phone number input',
  },
  'account.settings.coaching.consent.success.header': {
    id: 'account.settings.coaching.consent.success.header',
    defaultMessage: 'Success!',
    description: 'Heading announcing that submission succeeded',
  },
  'account.settings.coaching.consent.success.message': {
    id: 'account.settings.coaching.consent.success.message',
    defaultMessage: "You're signed up for coaching. You can expect a message via email or SMS in the coming days.",
    description: 'Text announcing that you have signed up and will receive texts',
  },
  'account.settings.coaching.consent.success.continue': {
    id: 'account.settings.coaching.consent.success.continue',
    defaultMessage: 'Start my course',
    description: 'Text that the user will be sent back to the courseware',
  },
  'account.settings.coaching.managed.support': {
    id: 'account.settings.coaching.managed.support',
    defaultMessage: 'support',
    description: 'website support',
  },
});

export default messages;
